import { Component, ElementRef, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import moment from 'moment';
import { ReducerUtilityService as ReducerUtilityService2 } from 'src/app/shared/utility-services/reducer-utility.service';

@FormComponentLookup('inner-html')
@Component({
    selector: 'app-inner-html',
    templateUrl: './inner-html.component.html',
    styleUrls: ['./inner-html.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InnerHtmlComponent extends FormEntryComponentClass {

  @ViewChild('entryRef') entryRef: ElementRef;
  value: any = [];
  safeHtml: SafeHtml;

  constructor(private reducerUtilitySrvc: ReducerUtilityService2, private domSanatizer: DomSanitizer) {
    super();
  }


  ngOnInit() {
    this.value = [];

    if (this.entry?.base?.textArray?.length) {
      this.entry.base.text = this.entry.base.textArray.join('');
    }

    if (this.entry?.custom?.textSafeHtml) {
      this.safeHtml = this.domSanatizer.bypassSecurityTrustHtml(this.entry.base.text);
    }
    
    if (this.entry?.custom?.values?.valuesFromState) {
      for (const obj of this.entry.custom.values.valuesFromState) {
        // TODO: remove formControlAttributes from all the form configs so this can be simplified to just the custom connect path.
        const connectPathToUse = this.entry.custom?.values?.connectPath || this.entry?.formControlAttributes?.connectPath;
        let val = this.reducerUtilitySrvc.getGlobalStateItem(connectPathToUse + '.' + obj);
        if (obj === 'dob') {
          val = moment(val).format('MM/DD/YYYY');
        }

        // Avoid pushing empty strings - they just add whitespace to the view
        if (val) {
          this.value.push(val);
        }
      }

      if (this.entry.custom.values.valueFromSystem === 'sysdate') {
        this.value.push(moment().format('MM/DD/YYYY'));
      }

      //TODO: make more configurable
      if (this.entry.custom.values.valueFromSystem === 'fullname') {
        // Logic for spouses, etc.
        let connectPath = "individualMarket.ratingInfo.subscriber.0";
        if (this.entry?.custom.values?.connectPath) {
          connectPath = this.entry.custom?.values?.connectPath || this.entry?.formControlAttributes?.connectPath;
        }
        let firstName = this.reducerUtilitySrvc.getPayloadState(`${connectPath}.firstName`);
        let lastName = this.reducerUtilitySrvc.getPayloadState(`${connectPath}.lastName`);
        let firstAndLast = firstName + " " + lastName;
        this.value.push(firstAndLast);
      }

      if (this.entry.custom.values.valueFromSystem === 'subscriberDobDisplay') {
        this.value.push(this.getDobDisplay('subscriber'));
      }
      if (this.entry.custom.values.valueFromSystem === 'spouseDobDisplay') {
        this.value.push(this.getDobDisplay('spouse'));
      }
      if (this.entry.custom.values.valueFromSystem === 'dependentDobDisplay') {
        this.value.push(this.getDobDisplay('dependent'));
      }
    }
  }

  getDobDisplay(relationship: string) {
    let connectPath = '';
    switch (relationship) {
      case 'subscriber':
        connectPath = "individualMarket.ratingInfo.subscriber.0";
        break;
      case 'spouse':
        connectPath = "individualMarket.ratingInfo.spousal-partner.0";
        break;
      case 'dependent':
        // helperId is not zero indexed
        const index = this.entry.formControlAttributes.helperId - 1;
        connectPath = `individualMarket.ratingInfo.dependents.${index}`;
        break;
    }
    if (this.entry?.custom.values?.connectPath) {
      connectPath = this.entry.custom?.values?.connectPath || this.entry?.formControlAttributes?.connectPath;
    }
    const dob = moment(this.reducerUtilitySrvc.getPayloadState(`${connectPath}.dob`)).format('MM/DD/YYYY');
    return dob;
  };
}
